import { Grid } from '@material-ui/core'
import React, { useCallback } from 'react'
import { HexColorPicker } from 'react-colorful'
import { useFormContext, useWatch } from 'react-hook-form'

import ImageEditor from '../../ImageEditor'
import { DispensaryHeroFormValues } from '../CustomizeHomePage'
import { DisabledOverlay } from '../DisabledOverlay'
import { RenderEntireImageAsCtaRadioGroup } from './RenderEntireImageAsCtaRadioGroup'
import * as Styled from './styled'

const HeroImageCreate: React.FC = () => {
  const { control, register, setValue } = useFormContext<DispensaryHeroFormValues>()
  const { ctaBackgroundColor, ctaTextColor, imageAssetRef, renderEntireImageAsCta, textColor } =
    useWatch<DispensaryHeroFormValues>({
      control,
      name: [
        'ctaBackgroundColor',
        'ctaTextColor',
        'imageAssetRef',
        'renderEntireImageAsCta',
        'textColor',
      ],
    })
  const handleChange = useCallback(
    (field: keyof DispensaryHeroFormValues, value: string) => {
      setValue(field, value, { shouldDirty: true })
    },
    [setValue],
  )

  return (
    <Styled.StyledGrid container spacing={5}>
      <Grid item xs={12}>
        <Styled.ImageEditorContainer>
          <ImageEditor
            sanityValue={imageAssetRef}
            handleSubmit={(e) => handleChange('imageAssetRef', e)}
            submitOnChange={true}
            noRemove={true}
            aspectRatio="hero"
          />
        </Styled.ImageEditorContainer>
      </Grid>
      <Grid item xs={12}>
        <Styled.InputContainer>
          <Grid item xs={12} sm={12}>
            <RenderEntireImageAsCtaRadioGroup defaultValue="no" name="renderEntireImageAsCta" />
          </Grid>
        </Styled.InputContainer>
      </Grid>
      <Styled.GridRelativePosition container item xs={12}>
        <Grid item xs={12} sm={4}>
          <Styled.InputContainer>
            <Styled.InputLabel>Paragraph Text Color *</Styled.InputLabel>
            <Styled.StyledHexColorInput
              color={textColor}
              onChange={(e) => handleChange('textColor', e)}
              prefixed
            />
          </Styled.InputContainer>
          <Styled.ColorPickerContainer>
            <HexColorPicker color={textColor} onChange={(e) => handleChange('textColor', e)} />
          </Styled.ColorPickerContainer>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Styled.InputContainer>
            <Styled.InputLabel>Button Background Color *</Styled.InputLabel>
            <Styled.StyledHexColorInput
              color={ctaBackgroundColor}
              onChange={(e) => handleChange('ctaBackgroundColor', e)}
              prefixed
            />
          </Styled.InputContainer>
          <Styled.ColorPickerContainer>
            <HexColorPicker
              color={ctaBackgroundColor}
              onChange={(e) => handleChange('ctaBackgroundColor', e)}
            />
          </Styled.ColorPickerContainer>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Styled.InputContainer>
            <Styled.InputLabel>Button Text Color *</Styled.InputLabel>
            <Styled.StyledHexColorInput
              color={ctaTextColor}
              onChange={(e) => handleChange('ctaTextColor', e)}
              prefixed
            />
          </Styled.InputContainer>
          <Styled.ColorPickerContainer>
            <HexColorPicker
              color={ctaTextColor}
              onChange={(e) => handleChange('ctaTextColor', e)}
            />
          </Styled.ColorPickerContainer>
        </Grid>
        {renderEntireImageAsCta === 'yes' && (
          <DisabledOverlay>
            Paragraph Text Color, Button Background Color and Button Text Color fields are disabled
            while Render Entire Image as CTA is enabled.
          </DisabledOverlay>
        )}
      </Styled.GridRelativePosition>
      <input type="hidden" name="imageAssetRef" ref={register} />
      <input type="hidden" name="textColor" ref={register} />
      <input type="hidden" name="ctaBackgroundColor" ref={register} />
      <input type="hidden" name="ctaTextColor" ref={register} />
    </Styled.StyledGrid>
  )
}

export default HeroImageCreate
